import { ADD_SERVER_ERROR, STOP_GLOBAL_LOADER } from '@/store/modules/common/mutation-types';
import { LOGOUT } from '@/store/modules/auth/mutation-types';
import Vue from 'vue';

export const errorFunc = (response, commit) => {
  commit(`common/${STOP_GLOBAL_LOADER}`, null, { root: true });
  commit(`common/${ADD_SERVER_ERROR}`, response, { root: true });
  if (response.message === 'Unauthenticated.' && response.status_code === 500) {
    commit(`auth/${LOGOUT}`, null, { root: true });
    Vue.router.push({
      name: 'login.index',
    });
  }
};

export default {
  errorFunc,
};



// WEBPACK FOOTER //
// ./src/utils/errorFunc.js